import { Result } from "../../models/result";

export const getPageOfResults = (
	results: Result[],
	page: number,
	resultsPerPage: number,
	totalPages: number,
) => {
	if (results === null || results === undefined) {
		return [];
	}

	if (results.length === 0) {
		return [];
	}

	let pageOfResults = [];

	let startIndex = (page - 1) * resultsPerPage;

	if (page === totalPages) {
		pageOfResults = results.slice(startIndex);
	} else {
		pageOfResults = results.slice(startIndex, startIndex + resultsPerPage);
	}

	return pageOfResults;
};
